import { v2API } from "@voxmarkets/api-sdk";
import StockChart from "./StockChart";

class ChartLoader extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      data: []
    };
  }

  componentDidMount() {
    const date = new Date();

    v2API.Charts.getByListingOT(
      this.props.listingID,
      Math.floor(Date.now() / 1000),
      this.props.days || 100
    ).then(data => {
      this.setState({
        data: data
      });
    });
  }

  render() {
    return (
      <div>
        {this.state.data.length > 0 && (
          <StockChart
            {...this.props}
            data={this.state.data}
            from={Date.now()}
          />
        )}
      </div>
    );
  }
}

export default ChartLoader;
